export default "__VITE_ASSET__C0nu_Dtr__"